import clientAxios from "../client";
import { get } from "../rest";

import { formatQueryString } from "@/common/utils/common";

import type { AddressType, QueryType } from "@/common/types/common";

export async function searchByCep(cep: string) {
  const cepNumber = cep?.replace(/\D/g, "");
  return await get(`https://viacep.com.br/ws/${cepNumber}/json/`);
}

export async function addressList(
  account_id: string,
  owner_id: string,
  query?: QueryType,
) {
  const queryString = formatQueryString(query);

  return await clientAxios.get(
    `account/${account_id}/address/${owner_id}/list${queryString}`,
  );
}

export async function addressCreate(
  account_id: string,
  owner_id: string,
  payload: AddressType,
) {
  return await clientAxios.post(
    `account/${account_id}/address/${owner_id}/create`,
    payload,
  );
}

export async function addressShow(account_id: string, address_id: string) {
  return await clientAxios.get(
    `account/${account_id}/address/${address_id}/show`,
  );
}

export async function addressUpdate(
  account_id: string,
  address_id: string,
  payload: AddressType,
) {
  return await clientAxios.put(
    `account/${account_id}/address/${address_id}/update`,
    payload,
  );
}

export async function addressDelete(account_id: string, address_id: string) {
  return await clientAxios.del(
    `account/${account_id}/address/${address_id}/delete`,
  );
}
